import { ref, remove } from "firebase/database";
import { db } from "../../../../firebase";

export const DeleteBooking = (firebaseKey) => remove(ref(db, `BookingBusiness/${firebaseKey}`));
